module.exports = __webpack_public_path__ + "assets/img/huanggongfen_2.2f0cba91.jpg";